<p-calendar
  [showIcon]="true"
  [selectionMode]="selectionMode"
  icon="pi pi-datepicker"
  [showTime]="showTime"
  [stepMinute]="stepMinute"
  [keepInvalid]="true"
  [view]="view"
  [defaultDate]="defaultDate"
  [dateFormat]="primeDateFormat"
  [selectionMode]="selectionMode"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [appendTo]="appendTo"
  [timeOnly]="timeOnly"
  [yearNavigator]="true"
  [monthNavigator]="true"
  [readonlyInput]="readonlyInput"
  [hideOnDateTimeSelect]="hideOnDateTimeSelect"
  [ngClass]="{ 'p-fluid': true }"
  [baseZIndex]="2000"
  (onBlur)="onBlur($event)"
  (onInput)="onInput()"
  (onSelect)="onSelect($event)"
  (onFocus)="onFocus($event)"
  (onShow)="onShow($event)"
  (onClear)="onClear($event)"
>
  <ng-template pTemplate="footer">
    <div
      *ngIf="showTime && !timeOnly"
      class="p-calendar-time-footer"
      (click)="onPanelOKBtnClick()"
    >
      OK
    </div>
  </ng-template>
  <ng-template pTemplate="date" let-dateInfo>
    <div [attr.data-overlay-panel-id]="overlayPanelId">{{ dateInfo.day }}</div>
  </ng-template>
</p-calendar>
<ng-container *ngIf="control?.invalid && (control?.dirty || control?.touched)">
  <small *ngIf="control?.errors?.['invalidDate']" class="p-error">
    {{ fieldName | translate }} {{ validationMsgMap.invalidDate | translate }}
  </small>
</ng-container>
